// THIS IS AN AUTOGENERATED FILE. DO NOT MODIFY.
import { createIcon } from './utils/createIcon';

export const TrendingDown = createIcon(
  <path
    clipRule="evenodd"
    d="M5 3C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5ZM17.133 10.3354C17.133 9.83831 16.73 9.43537 16.233 9.43538C15.7359 9.43538 15.333 9.83833 15.333 10.3354L15.333 14.0601L8.37109 7.09818C8.01962 6.7467 7.44977 6.7467 7.0983 7.09818C6.74683 7.44965 6.74683 8.0195 7.0983 8.37097L14.0603 15.3329L10.3354 15.3329C9.83839 15.3329 9.43545 15.7359 9.43544 16.2329C9.43544 16.73 9.83839 17.1329 10.3354 17.1329L16.233 17.1329C16.4717 17.1329 16.7007 17.0381 16.8694 16.8693C17.0382 16.7005 17.1331 16.4716 17.133 16.2329L17.133 10.3354Z"
    fillRule="evenodd"
  />,
);
